import { render, staticRenderFns } from "./SettlementInfo.vue?vue&type=template&id=58b571b9&scoped=true&"
import script from "./SettlementInfo.vue?vue&type=script&lang=js&"
export * from "./SettlementInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettlementInfo.vue?vue&type=style&index=0&id=58b571b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b571b9",
  null
  
)

export default component.exports